import React from 'react';
import { GoalScorerMarket } from 'src/domains/sportsbook/webview/components/goalscorerMarketGroupUnified/GoalScorerMarket';
import { GoalScorerMarketState } from 'src/domains/sportsbook/webview/components/goalscorerMarketGroupUnified/GoalScorerMarket.state';
import { MarketHeader } from 'src/domains/sportsbook/webview/components/marketHeader/MarketHeader';
import { observer } from 'src/utils/mobx-react';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';

interface PropsType {
    headerName: string;
    eventId: EventId;
    marketId: MarketId;
    selections: Record<string, Array<SelectionModel>>;
    isOpen: boolean;
    onClick: () => void;
}

export const GoalscorerMarketGroupUnified = observer('GoalscorerMarketGroupUnified', (props: PropsType) => {
    const { headerName, isOpen, onClick, selections, marketId } = props;

    const goalScorerState = new GoalScorerMarketState(selections);

    const event = props.eventId.getEventModel();

    if (event === null) {
        return null;
    }

    return (
        <div className='market-group--goalscorer'>
            <MarketHeader
                name={headerName ?? 'First Goalscorer'}
                isOpen={isOpen}
                onClick={onClick}
                marketId={marketId}
            />
            {isOpen ? <GoalScorerMarket state={goalScorerState} /> : null}
        </div>
    );
});
